import React from 'react';

import gift from '../../../assets/images/gift.svg';

import styles from './ExperientialRewardsPill.module.scss';

const ExperientialRewardsPill = () => (
  <div className={styles.mainContainer}>
    <img className={styles.iconStyles} src={gift} alt="gift" />
  </div>
);

export default ExperientialRewardsPill;
